import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'

const Connector = styled.div`
  width: ${rem(48)};
  min-width: ${rem(20)};
  height: 1px;
  background-color: ${props => props.theme.palette.neutral.default.five};
`

/**
 * The line to separate `<Step />`s horizontally.
 */
function StepConnector() {
  return <Connector role="separator" />
}

export default StepConnector
